import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import analyticsDataReducer from '../data/analyticsDataSlice';
import queriedAssetsReducer from '../data/assets/queriedAssetsSlice';
import dashboardDefsDataReducer from '../features/visual-analytics/data/dashboardsSlice';

import externalDataReducer from '../externalData/externalDataSlice';
import templateSliceReducer from '../data/templateSlice';
import taskExecutionSliceReducer from '../data/taskExecutionSlice';
import taskDefinitionSliceReducer from '../data/taskDefinitionSlice';
import pollingReducer from '../data/pollingSlice';

export const store = configureStore({
  reducer: {
    analyticsData: analyticsDataReducer,
    externalData: externalDataReducer,
    dashboardDefs: dashboardDefsDataReducer,
    queriedAssets: queriedAssetsReducer,
    template: templateSliceReducer,
    taskExecution: taskExecutionSliceReducer,
    taskDefinitionList: taskDefinitionSliceReducer,
    polling: pollingReducer,
  },
  // These actions contain data that is not relevant to the Redux state, but carry
  // very large payloads (e.g. the entire dashboard state).
  // We ignore them in the serializable check to avoid warnings.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['analyticsData/commitDashboardStateReplay', 'analyticsData/pasteDataContextSelection'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
